// The report page's display saves (each goal's graph gear, the page-wide graph gear, the panel
// toggles) all fold one change into the same row on the server. Sent as they are clicked, two can
// be in flight at once and land in either order, and the report keeps whichever the server finished
// last: the page shows one thing and the PDF prints another. So they go one at a time, each once
// the one before it has been answered, and each request is built when its turn comes, carrying the
// page as it stands by then.
let tail = Promise.resolve();

/**
 * @param {() => Promise<any>} send builds and sends the request
 * @returns {Promise<any>} settles as the request does
 */
export function queueDisplaySave(send) {
  const turn = tail.then(send);
  // A save that failed holds up nothing behind it; its own caller hears about it.
  tail = turn.catch(() => {});
  return turn;
}

// Forgets whatever is queued, for specs.
export function resetDisplaySaves() {
  tail = Promise.resolve();
}
